import { render } from "./GroupFormCL.vue?vue&type=template&id=728c8cf0"
import script from "./GroupFormCL.vue?vue&type=script&lang=js"
export * from "./GroupFormCL.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__